import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController, MenuController } from 'ionic-angular';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthProvider } from '../../providers/auth/auth';
import { ENV } from '@app/env'
import { PatientsPage } from '../patients/patients';
import { AdminPrescriptionsPage } from '../admin-prescriptions/admin-prescriptions';
import {AdminOrdersPage} from "../admin-orders/admin-orders";

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {

  credentialsForm: FormGroup;
  versionnumber: any;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    private formBuilder: FormBuilder,
    private auth: AuthProvider,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    public menu: MenuController,
  ) {
    this.menu.enable(false);

    this.credentialsForm = this.formBuilder.group({
      email: [''],
      password: ['']
    });

    this.versionnumber = ENV.MODE + ' - ' + ENV.VERSION;
  }

  ionViewDidLoad() {}
  
  ionViewWillEnter() {
    this.menu.enable(false);
  }
    
    
ionViewWillLeave() {
    this.menu.enable(true);
}

  async login() {
    let email = this.credentialsForm.controls.email.value;
    let password = this.credentialsForm.controls.password.value;
    if(!email || !password) {
      const alert = this.alertCtrl.create({
        title: 'Login Failure',
        subTitle: 'Please enter a valid email and password',
        buttons: ['OK']
      });
      alert.present();
      return
    }
    const loader = this.loadingCtrl.create({
      content: "Signing In..."
    });

    loader.present()

    await this.auth.emailLogin(email, password)
    .then(async(t) => {
      loader.dismiss()
      await this.auth.getCurrentUser().then(user => {
        if(user.roles.retina_pharmacist || user.roles.retina_reporting)  {
          this.navCtrl.setRoot(AdminOrdersPage)
        } else {
          this.navCtrl.setRoot(PatientsPage)
        }
      });
      
    })
    .catch((err) => {
      let error: string = err.toString();
      error = error.replace('Error: Error: ','');
      loader.dismiss()
      const alert = this.alertCtrl.create({
        title: 'Login Failure',
        subTitle: error,
        buttons: ['OK']
      });
      alert.present();
    });

    
  }

  async resetPassword() {
    const emailprompt = this.alertCtrl.create({
      title: 'Reset Password',
      inputs: [
        {
          name: 'email',
          placeholder: 'Email'
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: data => {
          }
        },
        {
          text: 'Send Reset Email',
          handler: data => {
            let emailaddress = data.email;
            const loader = this.loadingCtrl.create({
              content: "Sending Reset Email..."
            });
        
            loader.present()
        
            this.auth.sendPasswordResetEmail(emailaddress)
            .then(() => {
              loader.dismiss()
            })
            .catch(() => {
              loader.dismiss()
            });

        
            
          }
          }
      ]
    });
    emailprompt.present();
    
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts